import styled from "@emotion/styled";
import { Card } from "react-bootstrap";
import { DEFAULT_CARD_STYLES } from "../../../shared/styles/Card.styles";
import { IStyledComponentProps } from "../../../theme/theme.types";

const PackageDetailsCard = styled(Card)<IStyledComponentProps>`
  &.package-details-card {
    ${DEFAULT_CARD_STYLES}
  }
`;

const PackageDetailsHeader = styled(Card.Header)<IStyledComponentProps>`
  &.package-details-header {
    background-color: ${(props) => props.theme.colors.essential.white};
    border-radius: 0;

    .package-icon {
      font-size: 24px;
    }

    h4 {
      color: ${(props) => props.theme.colors.grays.septenary};
      margin: 12px 0;
    }

    // Note: Need to keep this around, since we need to use
    // bootstraps badge component when there are tool-tips needed
    .badge {
      border-radius: 0;
      width: 72px;
      font-size: 11px;
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      padding: 6px 0;

      @media (min-width: ${(props) =>
          props.theme.utils.getThemeBreakpoint("tablet")}) {
        &.badge-tooltip {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      padding-left: 0;
      padding-right: 0;

      h4 {
        margin: 0;
      }
      .mobile-stack {
        margin: 12px 0;
      }
    }
  }
`;

const PackageDetailsBody = styled(Card.Body)<IStyledComponentProps>`
  &.package-details-body {
    padding: 0;
  }
`;

export default {
  PackageDetailsCard,
  PackageDetailsHeader,
  PackageDetailsBody,
};
